import Base from 'app/models/base';
import { appUrl } from 'utils/wrappers';

export default Base.extend({
  urlRoot: appUrl('addresses'),

  nameAndCompany() {
    const name = this.get('name');
    const company = this.get('company');
    let result = '';

    if (name && company) {
      result = `${company} c/o ${name}`;
    } else if (name) {
      result = name;
    } else if (company) {
      result = company;
    }

    return result;
  },

  cityStateZipCountry() {
    return [this.cityState(), this.get('zip'), this.get('country')].filter(s => s).join(' ');
  },

  cityState() {
    return [this.get('city'), this.get('state')].filter(s => s).join(', ');
  },

  addressArray() {
    return [
      this.nameAndCompany(),
      `${this.get('street1') || ''} ${this.get('street2') || ''}`,
      this.cityStateZipCountry(),
    ];
  },
});



// WEBPACK FOOTER //
// ./app/models/address.js